<template>
    <div class="reviewBlock">
        <div class="col-12">
        <h2 class="title-6 titleColor boldFont fontSmooth">{{ label('shop.reviews.title')}} ({{ reviews.length }})</h2>
            <a href="javascript:;" class="button small regularFont grey floatRightI mt-5" v-if="can_write_review && product_id" @click="toggleReviewForm()" v-text="reviewButtonText"></a>
        </div>
        <div class="col-12 reviewForm p20 blueLightBack mt20" v-if="showReviewForm">
            <div v-if="!reviewSent && !isSending">
                <input type="hidden" id="reviewform-recaptcha" v-model="form.recaptcha" name="recaptcha" value="" />
                <span class="alert alert-danger redColor" v-if="errors && errors.recaptcha" v-text="errors.recaptcha[0]"></span>
                <star-rating class="mb20"
                    v-model="form.stars"
                    :increment="0.5"
                    :rating="5"
                    :read-only="false"
                    :star-size="25"
                    :show-rating="false"
                    active-color="#ff9b00">
                </star-rating>

                <div class="col-12 mb5">
                    <input type="text" class="input" v-model="form.name" :placeholder="label('shop.reviews.form.name')" />
                    <span class="alert alert-danger redColor" v-if="errors && errors.name" v-text="errors.name[0]"></span>
                </div>
                <div class="col-12 mb5">
                    <input type="email" class="input" v-model="form.email" :placeholder="label('shop.reviews.form.email')" />
                    <span class="alert alert-danger redColor" v-if="errors && errors.email" v-text="errors.email[0]"></span>
                </div>
                <div class="col-12 mb5">
                    <input type="text" class="input" v-model="form.title" :placeholder="label('shop.reviews.form.title')" />
                    <span class="alert alert-danger redColor" v-if="errors && errors.title" v-text="errors.title[0]"></span>
                </div>
                <div class="col-12 mb5">
                    <textarea class="input" v-model="form.content" :placeholder="label('shop.reviews.form.content')"></textarea>
                    <span class="alert alert-danger redColor" v-if="errors && errors.content" v-text="errors.content[0]"></span>
                </div>
                <span class="paragraph floatRightI" v-text="label('shop.reviews.form.required')"></span>
                <button class="button green small mt10" @click="submitReview()" v-text="label('shop.reviews.form.button')"></button>
            </div>
            <div v-else-if="isSending">
                Sending...
            </div>
            <div class="paragraph" v-else>
                {{ label('shop.reviews.form.thanks') }}
            </div>
        </div>

        <div class="col-12 reviewList" v-if="reviews.length" v-for="review in reviews" :key="review.id">
            <review :review="review"></review>
        </div>
        <div class="paragraph" v-else>
           {{ label('shop.reviews.empty') }}
        </div>
    </div>
</template>

<script>
import Review from "./Review";
import translations from "../mixins/translations";

export default {
    name: "ReviewList",
    mixins: [translations,],
    components: {Review},
    props: {
        reviews: {
            required: true,
            type: Array
        },
        product_id: {
            required: false,
            type: Number,
            default: null
        },
        can_write_review: {
            required: false,
            type: Boolean,
            default: true
        },
        recaptchaKey: {
            type: String,
            required: true,
        }
    },
    data () {
        return {
            errors: null,
            showReviewForm: false,
            reviewSent: false,
            isSending: false,
            form: {
                stars: 5,
                name: null,
                title: null,
                email: null,
                content: null,
                recaptcha: null
            },
            recaptchaLoaded: false,
        }
    },
    methods: {
        toggleReviewForm() {
            this.showReviewForm = !this.showReviewForm;

            if(!this.recaptchaLoaded){
                let head = document.getElementsByTagName('head')[0];
                let script = document.createElement('script');
                script.type = 'text/javascript';

                script.src = "https://www.google.com/recaptcha/api.js?render=6Lfh5VEcAAAAAEXBTNqkfvMj3GvAFhRU1IZiAYZp";
                head.appendChild(script);

                this.recaptchaLoaded = true;
            }
        },
        submitReview() {
            this.isSending = true;
            let that = this;
            let key = this.recaptchaKey;

            grecaptcha.ready(function() {
                grecaptcha.execute(key, {action: 'reviewform'}).then(function(token) {
                    that.form.recaptcha = token;

                    that.submitRequest(that);
                });
            });
        },
        submitRequest(that) {
            axios.post(`/api/site/reviews/`+that.product_id+`/store/`, that.form)
                .then(response => {
                    if (response.data.success === true) {
                        that.reviewSent = true;
                        that.isSending = false;
                        window.location = response.data.slug;
                    } else {
                        that.reviewSent = false;
                    }
                })
                .catch(error => {
                    that.errors = error.response.data.errors;
                    that.isSending = false;
                })
        }
    },
    computed: {
        reviewButtonText() {
            return this.showReviewForm ? this.label('shop.reviews.form.hide') : this.label('shop.reviews.form.show');
        }
    },
    mounted() {
        // this.setRecaptchaKey();
    }
}
</script>
